import React from "react";
import FormInput from "Common/Custom/FormInput";
import FormSubmitButton from "Common/Custom/FormSubmitButton";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";
import Switch from "Common/Custom/Switch";
import FormSelect from "Common/Custom/FormSelect";

const AddSlotForm = ({
    fields = [],
    values = {},
    errors = {},
    handleChange = () => {},
    handleSubmit = () => {},
    loading = false,
    title = "Slot",
    ZoneTypeOptions = [],
}) => {
    return (
        <PageBody onSubmit={handleSubmit} headerchildren={
            <HeadingOne>{title}</HeadingOne>
        }>
            {fields.map((field) => {
                if (field.type === "switch") {
                    return (
                        <Switch
                            key={field.name}
                            values={values[field.name]}
                            handleChange={handleChange}
                            error={errors[field.name]}
                            field={field}
                            ValueOne="1"
                            ValueTwo="0"
                            LabelOne="Active"
                            LabelTwo="Inactive"
                        />
                    );
                }
                if (field.type === "select") {
                    // Guard against undefined while zones are loading
                    const options = (ZoneTypeOptions || []).map((opt) => ({
                        value: opt.zone_list_id,
                        label: opt.zone_type,
                    }));
                    return (
                        <FormSelect
                            key={field.name}
                            field={field}
                            value={values[field.name]}
                            handleChange={handleChange}
                            options={options}
                            error={errors[field.name]}
                        />
                    );
                }
                return (
                    <FormInput
                        key={field.name}
                        field={field}
                        value={values[field.name]}
                        handleChange={handleChange}
                        error={errors[field.name]}
                    />
                );
            })}

            <FormSubmitButton
                label={`Create ${title}`}
                loading={loading}
                colSize="col-12"
                align="end"
            />
        </PageBody>
    );
};

export default AddSlotForm;
